// extracted by mini-css-extract-plugin
module.exports = {"sink":"Sinks_sink__1sJpb","revoke":"Sinks_revoke__2NxO-"};